module.exports = __webpack_public_path__ + "img/menu-food-1.6b89ef0f.webp";